import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ListingOrderState } from 'app/pages/Account/ListOrder/slice/types';

import { objectType } from 'types';
import { useInjectReducer } from 'utils/redux-injectors';

export interface orderCount_orderManagementI {
    success: number
    paymentPending: number
    waitingApprove: number
    cancel: number
}

export interface StateOrderManagementI {
    error?: any,
    loading: boolean,
    listOrder: any[],
    orderCount: orderCount_orderManagementI | undefined | objectType,
    optionsGetListOrder: {
        page: number,
        limit: number,
        search: any,
        orderState: string,
    },
}
export const initialState: StateOrderManagementI = {
    loading: false,
    listOrder: [],
    orderCount: undefined,
    optionsGetListOrder: {
        page: 1,
        limit: 50,
        search: undefined,
        orderState: 'success',
    },
};

const listingOrderSlice = createSlice({
    name: 'listingOrder_OrderManagement',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        setOrders(state, action: PayloadAction<any[]>) {
            state.listOrder = action.payload;
        },

        setOrderCount(state, action: PayloadAction<objectType | undefined>) {
            state.orderCount = action.payload;
        },

        setOptions(
            state,
            action: PayloadAction<Partial<any>>,
        ) {
            const { page, search, orderState } = action.payload;

            if (search !== undefined) {
                state.optionsGetListOrder.search = search;
                state.optionsGetListOrder.page = 1;
            }

            if (orderState !== undefined) {
                state.optionsGetListOrder.orderState = orderState;
                state.optionsGetListOrder.page = 1;
            }

            if (page !== undefined) {
                state.optionsGetListOrder.page = page;
            }
        },

        resetState: () => initialState,
    },
});

export const listingOrderReducer = listingOrderSlice.reducer;
export const listingOrderActions = listingOrderSlice.actions;
// ✅ THÊM CÁI NÀY
export const useListingOrderSlice = () => {
    useInjectReducer({ key: listingOrderSlice.name, reducer: listingOrderSlice.reducer });
    return { actions: listingOrderSlice.actions };
};